import { useEffect } from "react";
import { Outlet, Navigate } from "react-router-dom";

const PrivateRoute = () => {
    const user = JSON.parse(localStorage.getItem("userData"));

    useEffect(() => {
        checkAuth()
    }, [])
    const checkAuth = async () => {
        let res = await fetch("/api/Auth/checkIsAuth", {
            method: "POST",
            headers: { 'token': user.token },
        })
        const resJson = await res.json();
        localStorage.setItem("userData", JSON.stringify({
            ...user,
            authStatus: resJson.authStatus,
        }))
        if (!resJson.authStatus) {
            localStorage.removeItem(user);
            localStorage.clear();
        }
    }


    return (
        user.authStatus ? <Outlet /> : <Navigate to="/" />
    )

}
export default PrivateRoute;